import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUi from 'photoswipe/dist/photoswipe-ui-default';
import template from './photoswipe.template';
import VueComponent from '../../js/modules/vue-component';
import VideoModal from '../video-modal.vue';

const videoInstance = {
  vueInstance: null,
  $wrapper: null,
};

const destroyVideo = () => {
  videoInstance.vueInstance.$destroy();
  videoInstance.$wrapper.empty();
};

const VIDEO_CLASS = 'js--photoswipe-video-wrapper';

const getVideoWrapperHtml = ({ placeholder, uuid, video }) => `
  <div
    class="pwsp__video ${VIDEO_CLASS}"
    data-placeholder="${placeholder}"
    data-uuid="${uuid}"
    data-url="${video}"
  </div>
`;

const appendTemplateToBody = () => {
  const div = document.createElement('div');
  div.innerHTML = template;
  const templateElement = div.children[0];
  return document.body.insertAdjacentElement('beforeend', templateElement);
};


const Photoswipe = ({ items, options = {} }) => {
  const templateNode = appendTemplateToBody();
  const itemsWithUuid = items.map((item) => ({ ...item, uuid: uuidv4() }));
  const photoswipe = new PhotoSwipe(templateNode, PhotoSwipeUi, itemsWithUuid, options);

  photoswipe.listen('gettingData', (index, item) => {
    if (!item.isVideo || item.isVideoInivialized) {
      return;
    }

    // PhotoSwipe API requires attributes mutation: https://photoswipe.com/v4-docs/custom-html-in-slides.html
    // eslint-disable-next-line no-param-reassign
    item.isVideoInivialized = true;
    // eslint-disable-next-line no-param-reassign
    item.html = getVideoWrapperHtml({
      placeholder: item.src,
      video: item.videoURL,
      uuid: item.uuid,
    });
    // eslint-disable-next-line no-param-reassign
    item.src = undefined;
  });

  photoswipe.listen('afterChange', () => {
    if (videoInstance.vueInstance) {
      destroyVideo();
    }

    const { uuid, isVideo } = photoswipe.currItem;

    if (!isVideo) {
      return;
    }

    const $videoWrapper = $(`.${VIDEO_CLASS}`).filter((index, el) => $(el).data('uuid') === uuid);
    const { url, placeholder } = $videoWrapper.data();
    const $vueComponentWrapper = $('<div />');
    $videoWrapper.empty().append($vueComponentWrapper);

    const video = VueComponent($vueComponentWrapper.get(0), VideoModal, {
      video: url,
      placeholder,
    });

    videoInstance.vueInstance = video.init();
    videoInstance.$wrapper = $videoWrapper;
  });

  photoswipe.listen('destroy', () => {
    if (videoInstance.vueInstance) {
      destroyVideo();
    }
  });

  return photoswipe;
};

export const getUrlParams = () => {
  const { hash } = new URL(window.location.href);
  const { gid, pid } = hash
    .split('&')
    .filter((el) => el !== '#')
    .map((paramAndValue) => {
      const [param, value] = paramAndValue.split('=');

      return {
        param,
        value,
      };
    })
    .reduce(
      (acc, { param, value }) => ({
        ...acc,
        [param]: value,
      }),
      {
        gid: null,
        pid: null,
      },
    );

  return { gid, pid };
};

export default Photoswipe;
